/**
 *
 * @author: Matthew Rawson @ 26/09/2018 18:52
 * @description:
 * @notes:
 */
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {H4} from "@irati/ui/src/Headings"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import PillBadge from "../../ui/PillBadge/PillBadge"


const Component = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: ${padding.small};

  > * {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  ${minWidthMedia.tablet`
    flex-direction: row;
    align-items: center;

    > * {
      margin-bottom: 0;
      margin-right: ${padding.tiny};
      &:last-child {
        margin-right: 0;
      }
    }
  `}
`


const SectionTitle = ({title, badgeCopy, ...props}) => {
  const idNamespace = id("SectionTitle", props)

  return (
    <Component id={idNamespace}>
      <H4>{title}</H4>
      {badgeCopy && <PillBadge>{badgeCopy}</PillBadge>}
    </Component>
  )
}


SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  badgeCopy: PropTypes.string
}
SectionTitle.defaultProps = {
  badgeCopy: null
}

export default SectionTitle
